import {injectable} from 'inversify-props';
import {TypedJSON} from 'typedjson';

import {LoraForwarderGatewayConfiguration} from '@/model/lora/UdpPacketForwarder/LoraForwarderUdpConfig';
import {LoraPacketForwarderStats} from '@/model/lora/LoraPacketForwarderStats';

import {ILoraForwarderChirpStackService} from '@/services/lora/forwarder/ILoraForwarderChirpStackService.service';
import {LoraForwarderStdService} from '@/services/lora/forwarder/LoraForwarderStd.service';

@injectable()
export class LoraForwarderChirpStackService extends LoraForwarderStdService implements ILoraForwarderChirpStackService {

  constructor() {
    super('/lora/forwarder/chirpstack-gateway-bridge');
  }

  public async getBridgeConfigFile(): Promise<string> {
    return this.apiService.get(`${this.path}/bridge/config-file`);
  }

  public async setBridgeConfigFile(config: string): Promise<void> {
    return this.apiService.put(`${this.path}/bridge/config-file`, config);
  }

  public async getForwarderConfig(): Promise<LoraForwarderGatewayConfiguration> {
    const config = await this.apiService.get(`${this.path}/forwarder/config`);
    return new LoraForwarderGatewayConfiguration(config);
  }

  public async getForwarderConfigFileLocal(): Promise<string> {
    return this.apiService.get(`${this.path}/forwarder/config-file-local`);
  }

  public async setForwarderConfigFileLocal(config: string): Promise<void> {
    return this.apiService.put(`${this.path}/forwarder/config-file-local`, config);
  }

  public async getForwarderConfigFileGlobal(): Promise<string> {
    return this.apiService.get(`${this.path}/forwarder/config-file-global`);
  }

  public async setForwarderConfigFileGlobal(config: string): Promise<void> {
    return this.apiService.put(`${this.path}/forwarder/config-file-global`, config);
  }

  // TODO: move this, it should be done in a child component
  public async getConfig(): Promise<LoraForwarderGatewayConfiguration> {
    return this.getForwarderConfig();
  }

  public async getConfigFileLocal(): Promise<string> {
    return this.getForwarderConfigFileLocal();
  }

  public async setConfigFileLocal(config: string): Promise<void> {
    return this.setForwarderConfigFileLocal(config);
  }

  public async getConfigFileGlobal(): Promise<string> {
    return this.getForwarderConfigFileGlobal();
  }

  public async setConfigFileGlobal(config: string): Promise<void> {
    return this.setForwarderConfigFileGlobal(config);
  }

  public async getStats(): Promise<LoraPacketForwarderStats> {
    return this.statsSerializer.parse(await this.apiService.get(`${this.path}/stats`))!;
  }

  public async resetStats(): Promise<void> {
    return await this.apiService.post(`${this.path}/stats/reset`, null);
  }
}
